import { render } from "./ProjectSortIndex.vue?vue&type=template&id=352910fe"
import script from "./ProjectSortIndex.vue?vue&type=script&lang=js"
export * from "./ProjectSortIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__